import { type State } from './state.type';

export const stateInitializer = (): State => {
	return null;
};
